<template>
  <v-row v-if="selectedDate" :style="{ padding: isMobile ? '20px' : '20px' }">
    <v-col
      cols="12"
      sm="12"
      md="6"
      v-if="plans"
      style="padding: 10px;"
    >
      <custom-datepicker
        v-model="selectedDate"
        @input="handleSelectPlan"
        :closeOnSelect="true"
        :outlined="true"
        :dense="true"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="6"
      v-if="plans"
      style="padding: 10px;"
    >
      <v-select
        v-model="selectedPlanID"
        :items="plans"
        @change="handleSelectPlan"
        dense
        outlined
        hide-details
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      md="4"
      lg="2"
      v-for="e of events"
      :key="e.ID"
      @click="handleSelectEvent(e)"
    >
      <event
        :data="e"
      />
    </v-col>
    <v-col
      cols="12"
      sm="12"
      v-if="selectedPlanID"
    >
      <event-pax-count
        :selectedEvent="selectedEvent"
        :onClose="handleClose"
        :selectedPlanID="selectedPlanID"
      />
    </v-col>
  </v-row>
</template>
<script>
import api from '@/services/api'
import utils from '@/services/utils'
import CustomDatepicker from '@/components/CustomDatepicker'
import Event from './Event'
import EventPaxCount from './EventPaxCount'
export default {
  components: {
    CustomDatepicker,
    Event,
    EventPaxCount,
  },
  data: () => ({
    loading: false,
    plans: [],
    selectedDate: null,
    selectedPlanID: null,
    events: [],
    selectedEvent: null,
  }),
  computed: {
    contentTypeID () {
      return this.$route.params.id
    },
    userID () {
      return utils.getUser()
    },
    isMobile () {
      return utils.isMobile() 
    },
  },
  mounted () {
    this.selectedDate = new Date().toISOString().split('T').shift()
    this.handleGetPlans() 
  },
  methods: {
    pad: function (value, nItem = 2) {
      let aux = ''
      for (let i = 0; i < nItem; i++) aux = aux.concat('0')
      let result = aux.concat(value)
      result = result.substring(result.length - nItem, result.length)
      return result
    },
    convertTime (v) {
      if (!v) return '00:00'

      const h = v / 60 | 0
      const m = v - (h * 60)
      return `${this.pad(h)}:${this.pad(m)}`
    },
    /*
    prepareDate (v) {
      const date = this.dates.filter(x => x.id === v).map(item => item.value).shift()
      if (!date) return 
      const month = new Date(date).toLocaleString('default', { month: 'long' }).substring(0,3)
      return `${date.split('-').pop()} ${month.toUpperCase()}`
    },
    */
    async handleGetPlans () {
      try {
        this.plans = await new Promise((resolve) => api.getAllWithoutLimit('system', `v1/internal/users/${this.userID}/activity-barcelo-01-permissions-pax-count`)
          .then(response => {
            resolve(response && response.length > 0 ? JSON.parse(response) : [])
          })
          .catch(error => {
            console.log(error)
            resolve(null)
          }))
        if (this.plans && this.plans.length > 0) this.selectedPlanID = this.plans[0]
        this.handleSelectPlan()
      } catch (error) {
        console.log(error)
      }
    },
    handleSelectPlan () {
      this.events = []
      if (!this.selectedPlanID) return
      api.getAllWithoutLimit ('dviewcontent', `v1/public/activity-barcelo-01/events/${this.contentTypeID}/${this.selectedPlanID}/${this.selectedDate}`)
        .then((response) => {
          this.events = response ? response.map(item => {
              let title = item.Title ? JSON.parse(item.Title) : null
              let description = item.Description ? JSON.parse(item.Description) : null
              const contentType = {
                color: '#FFFFF'
              }
              const category = contentType && contentType.category
                ? contentType.category.filter(x => x.id === item.CategoryID).shift() 
                : null
              
              let place = item.Place ? JSON.parse(item.Place) : null

              return {
                id: item.ID,//title.es.toUpperCase(),
                categoryID: item.CategoryID,
                title: title,
                description: description,
                isMorning: item.Time < 780,//720,
                time: `${this.convertTime(item.Time)} - ${this.convertTime(item.TimeEnd)}`,
                subtitle: null,
                image: item.Image,
                reservationRequired: item.ReservationRequired,
                place,
                tag: category ? category.name : null, //this.getTranslation(category.name, this.locale) : null,
                color: contentType.color,
                timeColor: contentType.color,
                reservable: item.Reservable,
                PVPHosted: item.PVPHosted,
                PVPNoHosted: item.PVPNoHosted,
                allTimes: item.AllTimes,
                adults: item.Adults ? item.Adults : 0,
                children: item.Children ? item.Children : 0,
                source: item.Source,
                date: item.Date,
              }
          }) : []
        })
    },
    handleSelectEvent (v) {
      /*
      if (v.source === 'romantic') {
        alert('TEMPORALMENTE NO PERMITIDO')
        return
      }
      */
      this.selectedEvent = v
    },
    handleClose (refresh) {
      if (refresh) this.handleSelectPlan()
      this.selectedEvent = null
    },
  },
}
</script>

